import React from "react"

const AppContext = React.createContext({
  token: null,
})

export default AppContext
